import React from 'react'

const Employee = () => {
  return (
    <div>Employee Page</div>
  )
}

export default Employee